import { FC, SVGProps } from "react";

const CustomFieldsIcon: FC<SVGProps<SVGSVGElement>> = ({
	stroke = "#7370FF",
	...props
}) => (
	<svg
		width="24"
		height="24"
		viewBox="0 0 24 24"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g id="Custom Field">
			<g id="Vector">
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M4.8 7.8C4.13726 7.8 3.6 8.33726 3.6 9V14.8C3.6 15.4627 4.13726 16 4.8 16H6.74961C7.19144 16 7.54961 16.3582 7.54961 16.8C7.54961 17.2418 7.19144 17.6 6.74961 17.6H4.8C3.2536 17.6 2 16.3464 2 14.8V9C2 7.45361 3.2536 6.2 4.8 6.2H14.3992C14.841 6.2 15.1992 6.55817 15.1992 7C15.1992 7.44183 14.841 7.8 14.3992 7.8H4.8Z"
					fill="#7370FF"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M18.105 6.7568C18.5896 6.27223 19.2468 6 19.9321 6C21.3591 6 22.516 7.15684 22.516 8.58388C22.516 9.26917 22.2437 9.92639 21.7592 10.411L21.4795 10.6918L17.8258 7.03765L18.105 6.7568Z"
					fill="#7370FF"
				/>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M16.9396 7.80469L20.5921 11.4615L13.2128 18.8409C13.1112 18.9424 12.9735 18.9995 12.8298 18.9995H9.94155C9.64246 18.9995 9.4 18.757 9.4 18.458V15.5697C9.4 15.426 9.45706 15.2883 9.55862 15.1867L16.9396 7.80469Z"
					fill="#7370FF"
				/>
			</g>
		</g>
	</svg>
);

export { CustomFieldsIcon };
